export default __webpack_public_path__ + "3db2e8cfb205da89d27625d0e4454c16.png";